export default __webpack_public_path__ + "static/media/brother.c1ffc592.svg";